"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Graphic_1 = __importDefault(require("./graphics/Graphic"));
const Opening_1 = __importDefault(require("./opening/Opening"));
const FeatureTypeMap = {
    GRAPHIC: Graphic_1.default,
    OPENING: Opening_1.default,
};
function FeatureNode({ feature, input, svgScale, }) {
    const FeatureComponent = FeatureTypeMap[feature.type];
    return (react_1.default.createElement(FeatureComponent, { feature: feature, input: input, svgScale: svgScale || 1 }));
}
exports.default = FeatureNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmVhdHVyZU5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9GZWF0dXJlTm9kZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFDQSxrREFBaUQ7QUFDakQsaUVBQXlDO0FBQ3pDLGdFQUF3QztBQW9CeEMsTUFBTSxjQUFjLEdBQXlCO0lBQzNDLE9BQU8sRUFBRSxpQkFBTztJQUNoQixPQUFPLEVBQUUsaUJBQU87Q0FDakIsQ0FBQztBQUVGLFNBQXdCLFdBQVcsQ0FBQyxFQUNsQyxPQUFPLEVBQ1AsS0FBSyxFQUNMLFFBQVEsR0FDVTtJQUNsQixNQUFNLGdCQUFnQixHQUFHLGNBQWMsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdEQsT0FBTyxDQUNMLDhCQUFDLGdCQUFnQixJQUNmLE9BQU8sRUFBRSxPQUFPLEVBQ2hCLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLFFBQVEsSUFBSSxDQUFDLEdBQ3ZCLENBQ0gsQ0FBQztBQUNKLENBQUM7QUFiRCw4QkFhQyJ9